import { render, staticRenderFns } from "./DocumentObjectPreview.vue?vue&type=template&id=5b21f50e&"
import script from "./DocumentObjectPreview.vue?vue&type=script&lang=js&"
export * from "./DocumentObjectPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports